import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable()
export class UsuariosService {
  private usuariosSubject = new ReplaySubject<any[]>(1);
  usuarios$ = this.usuariosSubject.asObservable();
  constructor() {
    // Cargar datos desde localStorage al iniciar
    const data = localStorage.getItem('coloresUsuariosAvatar');
    if (data) {
      this.usuariosSubject.next(JSON.parse(data));
    }
  }

  // // 🔹 Método para actualizar y sobrescribir los datos
  // actualizarUsuarios(usuarios: any[]) {
  //   usuarios.forEach(usuario => {
  //     usuario['colorAvatar'] = this.getColorUsuario(usuario.nombreUsuario);
  //   });

  //   this.usuariosSubject.next(usuarios); // 🔥 Actualizar el BehaviorSubject
  //   localStorage.setItem('coloresUsuariosAvatar', JSON.stringify(usuarios)); // Guardar en localStorage
  // }

  // 🔹 Método para obtener el color del usuario o generarlo si no existe
  private getColorUsuario(nombre: string): string {
    let coloresGuardados = JSON.parse(localStorage.getItem('coloresUsuariosAvatar')) || {};

    if (!coloresGuardados[nombre]) {
      coloresGuardados[nombre] = this.generarColor(nombre);
      localStorage.setItem('coloresUsuariosAvatar', JSON.stringify(coloresGuardados));
    }

    return coloresGuardados[nombre];
  }

  // 🔹 Método para generar un color basado en el nombre
  private generarColor(nombre: string): string {
    let hash = 0;
    for (let i = 0; i < nombre.length; i++) {
      hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `#${('00000' + (hash & 0xffffff).toString(16)).slice(-6)}`;
  }

  // actualizarUsuarios(nuevosUsuarios: any[]) {
  //   this.usuariosSubject.next(nuevosUsuarios);
  // }

  actualizarUsuarios(usuarios: any[]) {
  usuarios.forEach(usuario => {
    usuario['colorAvatar'] = this.getColorUsuario(usuario.nombreUsuario);
  });

  this.usuariosSubject.next(usuarios); // 🔥 Actualizar el BehaviorSubject
  localStorage.setItem('coloresUsuariosAvatar', JSON.stringify(usuarios)); // Guardar en localStorage
}

  limpiarUsuarios() {
    this.usuariosSubject.next([]); // Limpia datos anteriores
  }
}



// WEBPACK FOOTER //
// ./src/providers/usuarios/usuarios.service.ts